import { FC } from "react";

import { FormType } from "@simplyk/common";

import { getVisibleTicketingPrizes } from "./helpers/getVisibleTicketingPrizes";
import { PrizesSection } from "./PrizesSection/PrizesSection";
import { RatesTitle } from "./RatesTitle/RatesTitle";
import { TicketingWithPrizes } from "./types";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { useLocaleContext } from "@/common/contexts/LocaleContext";

export const Prizes: FC = () => {
  const { formObject, formCurrency, formCategory, previewFocusedPrizeId } = useFormV2Context(FormType.Ticketing);
  const { locale } = useLocaleContext();
  const prizes = getVisibleTicketingPrizes(formObject as TicketingWithPrizes, locale);

  if (prizes.length === 0) {
    return null;
  }

  return (
    <>
      <PrizesSection prizes={prizes} currency={formCurrency} focusedPrizeId={previewFocusedPrizeId} />
      <RatesTitle formCategory={formCategory} />
    </>
  );
};
